import * as React from "react";
import { connect } from "react-redux";
import { Theme, createStyles } from '@mui/material/styles';;
import { withStyles, WithStyles } from '@mui/styles';;
import idssStyle from "../../../Configuration/SharedStyling";
import {
    IGenericUserProps,
    genericMapStateToProps
} from "../../../DataClasses/GenericUser";
import { Grid2 as Grid, Typography } from "@mui/material";
import UserManagerService from "../../Services/UserManagerService";
import { AjaxError } from "rxjs/ajax";
import { firstValueFrom } from "rxjs";
import { IUserRolePayload } from "../../../DataClasses/UsersData";
import SharedMaterialReactTable, { ISharedTableColumn } from "../../Shared/MaterialReactTable";

const styles = (theme: Theme) => createStyles({ ...idssStyle(theme) });
interface IAccountPageState {
    data: IUserRolePayload[];
    isLoading: boolean;
    redirect: boolean;
}
type IStylesProps = WithStyles<typeof styles>;

// VIEW
class AccountPageView extends React.Component<
    IGenericUserProps & IStylesProps,
    IAccountPageState
> {
    constructor(props: any) {
        super(props);
        this.state = {
            data: [],
            isLoading: true,
            redirect: false
        };
    }

    public componentDidMount() {
        this.RefreshModel();
    }

    private getTableColumns = (): ISharedTableColumn<IUserRolePayload>[] => [
        {
            accessorKey: 'entityId',
            header: 'Org ID',
            enableSorting: true,
            enableFiltering: true,
        },
        {
            accessorKey: 'entityName',
            header: 'Org Name',
            enableSorting: true,
            enableFiltering: true,
        },
        {
            accessorKey: 'roleType',
            header: 'Role Type',
            enableSorting: true,
            enableFiltering: true,
        },
        {
            accessorKey: 'roleName',
            header: 'Role Name',
            enableSorting: true,
            enableFiltering: true,
        },
    ];

    public render() {
        const { classes } = this.props;

        return (
            <Grid container={true} className={classes.gridRowFlex} spacing={2}>
                <Grid size={12}>
                    <Typography className={classes.submissionTitle}>
                        Account Page
                    </Typography>
                </Grid>
                <Grid size={12} key="userRoleListGrid">
                    <div className={classes.card}>
                        <SharedMaterialReactTable
                            data={this.state.data}
                            columns={this.getTableColumns()}
                            title="Your Account Roles"
                            isLoading={this.state.isLoading}
                            enablePagination={true}
                            enableSorting={true}
                            enableFiltering={true}
                            enableColumnActions={true}
                            enableRowActions={false}
                            initialState={{
                                pagination: { pageIndex: 0, pageSize: 10 },
                            }}
                            muiPaginationProps={{
                                rowsPerPageOptions: [10, 15, 20, 25, 50, 75, 100, 500, 1000],
                            }}
                            emptyMessage="No account roles found."
                        />
                    </div>
                </Grid>
            </Grid>
        );
    }
    private setRedirectState() {
        this.setState({ redirect: true });
    }
    private async RefreshModel() {
        this.setState({ isLoading: true });
        const userRetVal = await firstValueFrom(
            UserManagerService.GetAccountRolesForCurrentUser$(this.props.user)
        );
        if (userRetVal instanceof AjaxError || !userRetVal) {
            this.setRedirectState();
        }
        else {
            this.setState({
                data: userRetVal
            });
        }
        this.setState({ isLoading: false });
    }
}

// REDUX CONTAINER
const AccountPageWithState = connect<IGenericUserProps>(
    genericMapStateToProps
)(AccountPageView);

// STYLES CONTAINER
const AccountPage = withStyles(styles)(
    AccountPageWithState
);

export default AccountPage;
